import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66bea9fe")

_pushScopeId("data-v-66bea9fe")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "profile" }
const _hoisted_4 = { class: "profile-info" }
const _hoisted_5 = { class: "orders-info" }
const _hoisted_6 = { class: "order-info" }
const _hoisted_7 = { class: "order-info" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Validar Telefone", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "Aumente a integridade da sua conta", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Meus Dados", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "Minhas informações pessoais", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "Carteira", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, "Minha carteira digital (saldo, cartões, etc)", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "Precisa de ajuda?", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, "Entre em contato conosco", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "Sorteios", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, "Confira os sorteios ativos", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "Endereços", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "Meus endereços de entrega", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "Cupons", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, "Cupons disponíveis para você", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "Sessões ativas", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, "Minhas sessões no TheLivery", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "Sair", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, "Limpar informações do aplicativo e sair", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_profile_skeleton = _resolveComponent("profile-skeleton")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Perfil",
            "has-go-back": false,
            balance: $options.cashbackValue
          }, null, 8, ["balance"]),
          _createVNode("div", _hoisted_1, [
            ($setup.loadingRef)
              ? (_openBlock(), _createBlock(_component_profile_skeleton, { key: 0 }))
              : (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("span", null, _toDisplayString($options.name), 1),
                      _createVNode("p", null, _toDisplayString($options.email), 1)
                    ]),
                    _createVNode("div", _hoisted_5, [
                      _createVNode("p", _hoisted_6, _toDisplayString($setup.infoRef.orders_quantity || 0) + " pedidos ", 1),
                      _createVNode("p", _hoisted_7, _toDisplayString($setup.infoRef.ratings_count || 0) + " avaliações ", 1)
                    ])
                  ]),
                  _createVNode(_component_ion_grid, null, {
                    default: _withId(() => [
                      ($options.phoneVerified === 0)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 0,
                            onClick: $setup.sendCodePhone
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _hoisted_8,
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_row, { onClick: $setup.editProfile }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_10,
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.openWallet }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_12,
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.openFaq }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_14,
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.raffles }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_16,
                              _hoisted_17
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.address }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_18,
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.coupons }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_20,
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.openSessionsActive }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_22,
                              _hoisted_23
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ion_row, { onClick: $setup.logoff }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _hoisted_24,
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})